import React from 'react';
import { Box, Typography } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { motion } from 'framer-motion';

const VisionMissionSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  if (isMobile) {
    return (
      <Box
        id="vision"
        sx={{
          minHeight: '100vh',
          backgroundColor: '#1A1A1A',
          backgroundImage: 'url(/img/21.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          px: 2,
          py: 10,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <Box
          sx={{
            backgroundColor: '#F5F5F5',
            borderRadius: '10px',
            px: 2.5,
            py: 3,
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Oswald',
              fontSize: '38px',
              fontWeight: 700,
              color: '#1A1A1A',
              lineHeight: 0.95,
            }}
          >
            OUR VISION
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Oswald',
              fontSize: '38px',
              fontWeight: 700,
              color: '#2858A8',
              lineHeight: 0.95,
              mb: 2,
            }}
          >
            & MISSION
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Roboto',
              fontSize: '14px',
              fontWeight: 400,
              color: '#1A1A1A',
              lineHeight: 1.75,
            }}
          >
            We bring to you the essence of authentic and naturally sourced spices and tea, right at your doorstep!
          </Typography>
        </Box>

        <Box
          sx={{
            backgroundColor: 'rgba(8,8,8,0.78)',
            borderRadius: '10px',
            px: 2.5,
            py: 3,
            border: '1px solid rgba(255,255,255,0.12)',
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Oswald',
              fontSize: '30px',
              fontWeight: 700,
              color: '#A8C5E8',
              letterSpacing: '0.03em',
              mb: 1,
            }}
          >
            OUR MISSION
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Roboto',
              fontSize: '14px',
              fontWeight: 400,
              color: '#D4C5B0',
              lineHeight: 1.75,
              mb: 2,
            }}
          >
            Stretching from the Valleys of Kashmir to the Coasts of Malabar, from the Foothills of the Himalayas to the Plains of Gujarat, our goal is to promote the age-old spice and tea trade native to India.
          </Typography>

          <Typography
            sx={{
              fontFamily: 'Oswald',
              fontSize: '30px',
              fontWeight: 700,
              color: '#A8C5E8',
              letterSpacing: '0.03em',
              mb: 1,
            }}
          >
            OUR AIM
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Roboto',
              fontSize: '14px',
              fontWeight: 400,
              color: '#D4C5B0',
              lineHeight: 1.75,
            }}
          >
            We aim to create a community of conscious consumers and craft exquisite culinary experiences with the help of our flavour-packed spices and tea.
          </Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Box
      id="vision"
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        backgroundColor: '#1A1A1A',
        backgroundImage: 'url(/img/21.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      {/* <Box sx={{ position: 'absolute', top: { xs: 30, md: 50 }, left: { xs: 30, md: 50 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box
            sx={{
              width: { xs: 50, md: 70 },
              height: { xs: 50, md: 70 },
              borderRadius: '50%',
              backgroundColor: '#2858A8',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: '3px solid #5B8BC9',
            }}
          >
            <Box
              sx={{
                fontFamily: 'serif',
                fontSize: { xs: '24px', md: '32px' },
                fontWeight: 700,
                color: '#FFFFFF',
              }}
            >
              अ
            </Box>
          </Box>
          <Box>
            <Box
              sx={{
                fontFamily: 'Oswald',
                fontSize: { xs: '16px', md: '20px' },
                fontWeight: 500,
                color: '#FFFFFF',
                lineHeight: 1.2,
              }}
            >
              Arvira
            </Box>
            <Box
              sx={{
                fontFamily: 'Oswald',
                fontSize: { xs: '16px', md: '20px' },
                fontWeight: 500,
                color: '#FFFFFF',
                lineHeight: 1.2,
              }}
            >
              Creations
            </Box>
          </Box>
        </Box>
      </Box> */}

      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        style={{
          position: 'absolute',
          bottom: '-2%',
          left: '-2%',
          width: '50%',
          height: '60%',
        }}
      >
        <Box
          sx={{
            width: '100%',
            height: '100%',
            backgroundColor: '#F5F5F5',
            borderRadius: '12px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            px: { xs: 4, md: 6, lg: 8 },
            py: { xs: 4, md: 6 },
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Oswald',
              fontSize: { xs: '48px', sm: '64px', md: '80px', lg: '96px' },
              fontWeight: 700,
              color: '#1A1A1A',
              letterSpacing: '0.05em',
              lineHeight: 0.9,
              mb: 1,
            }}
          >
            OUR VISION
          </Typography>

          <Typography
            sx={{
              fontFamily: 'Oswald',
              fontSize: { xs: '48px', sm: '64px', md: '80px', lg: '96px' },
              fontWeight: 700,
              color: '#2858A8',
              letterSpacing: '0.05em',
              lineHeight: 0.9,
              mb: 4,
            }}
          >
            & MISSION
          </Typography>

          <Typography
            sx={{
              fontFamily: 'Roboto',
              fontSize: { xs: '14px', md: '16px', lg: '18px' },
              fontWeight: 400,
              color: '#1A1A1A',
              lineHeight: 1.8,
            }}
          >
            We bring to you the essence of authentic and naturally sourced spices and tea, right at your doorstep!
          </Typography>
        </Box>
      </motion.div>

      <Box
        sx={{
          position: 'absolute',
          right: '5%',
          top: '20%',
          width: '40%',
          display: 'flex',
          flexDirection: 'column',
          gap: 6,
        }}
      >
        <motion.div
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          <Box sx={{ display: 'flex', gap: 3, alignItems: 'flex-start' }}>
            <Box
              sx={{
                minWidth: { xs: 60, md: 80 },
                height: { xs: 60, md: 80 },
                borderRadius: '50%',
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                backdropFilter: 'blur(10px)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '2px solid rgba(255, 255, 255, 0.3)',
              }}
            >
              <svg
                width="40"
                height="40"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Box>
            <Box>
              <Typography
                sx={{
                  fontFamily: 'Oswald',
                  fontSize: { xs: '28px', md: '36px', lg: '42px' },
                  fontWeight: 700,
                  color: '#A8C5E8',
                  letterSpacing: '0.05em',
                  mb: 2,
                }}
              >
                OUR MISSION
              </Typography>
              <Typography
                sx={{
                  fontFamily: 'Roboto',
                  fontSize: { xs: '14px', md: '15px', lg: '16px' },
                  fontWeight: 400,
                  color: '#D4C5B0',
                  lineHeight: 1.8,
                }}
              >
                Stretching from the Valleys of Kashmir to the Coasts of Malabar, from the Foothills of the Himalayas to the Plains of Gujarat, our goal is to promote the age-old spice trade native to India.
              </Typography>
            </Box>
          </Box>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.5 }}
        >
          <Box sx={{ display: 'flex', gap: 3, alignItems: 'flex-start' }}>
            <Box
              sx={{
                minWidth: { xs: 60, md: 80 },
                height: { xs: 60, md: 80 },
                borderRadius: '50%',
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                backdropFilter: 'blur(10px)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '2px solid rgba(255, 255, 255, 0.3)',
              }}
            >
              <svg
                width="40"
                height="40"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.7088 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18455 2.99721 7.13631 4.39828 5.49706C5.79935 3.85781 7.69279 2.71537 9.79619 2.24013C11.8996 1.7649 14.1003 1.98232 16.07 2.85999"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M22 4L12 14.01L9 11.01"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Box>
            <Box>
              <Typography
                sx={{
                  fontFamily: 'Oswald',
                  fontSize: { xs: '28px', md: '36px', lg: '42px' },
                  fontWeight: 700,
                  color: '#A8C5E8',
                  letterSpacing: '0.05em',
                  mb: 2,
                }}
              >
                OUR AIM
              </Typography>
              <Typography
                sx={{
                  fontFamily: 'Roboto',
                  fontSize: { xs: '14px', md: '15px', lg: '16px' },
                  fontWeight: 400,
                  color: '#D4C5B0',
                  lineHeight: 1.8,
                }}
              >
                We aim to create a community of conscious consumers and craft exquisite culinary experiences with the help of our flavour-packed spices and tea.
              </Typography>
            </Box>
          </Box>
        </motion.div>
      </Box>
    </Box>
  );
};

export default VisionMissionSection;
